import { Button, Heading, Input, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getNochesLiberadas, downloadNochesLiberadasCSV } from "../../services/nochesUsuario";
import Select from 'react-select';
import { useDidUpdateEffect } from "../../util/util";
import { useTranslation } from "react-i18next";
import Pagination from "../util/pagination/pagination";


const Libreaciones = () => {

    const { t } = useTranslation();

    const [nochesLiberadas, setNochesLiberadas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedYear, setSelectedYear] = useState({
        label: new Date().getFullYear(),
        value: new Date().getFullYear()
    });
    const [yearList, setYearList] = useState([]);



    const requestAllNochesLiberadas = async () => {
        return await getNochesLiberadas(selectedYear.value, page, search, 'true');
    }

    const requestNochesLiberdadas = async () => {
        setLoading(true);
        try {
            const response = await getNochesLiberadas(selectedYear.value, page, search);
            setNochesLiberadas(response.data.nochesLiberadas);
            setTotalPages(response.data.totalPages);
            let oldestYear = new Date(response.data.oldestDate);
            const newestYear = new Date().getFullYear();
            if(isNaN(oldestYear)){
                setYearList([
                    {
                        label: newestYear,
                        value: newestYear
                    }
                ])
            }else{
                oldestYear = oldestYear.getFullYear();
                const years = [];
                for (let i = oldestYear; i <= newestYear; i++) {
                    years.push({
                        label: i,
                        value: i
                    });
                }
                setYearList(years);
            }
        } catch (error) {
            console.error("Error fetching noches liberadas:", error);
        } finally {
            setLoading(false);
        }
    }

    // Llama al backend para generar y descargar el CSV directamente, evitando timeouts.
    const generateCSV = async () => {
        setLoading(true);
        try {
            const response = await downloadNochesLiberadasCSV(selectedYear.value, search);
            
            // Crea un Blob a partir de la respuesta CSV del backend
            const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    
            // Crea un enlace temporal para iniciar la descarga
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute("download", `noches_liberadas_${selectedYear.value}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading CSV:", error);
            alert(t('CSV_DOWNLOAD_ERROR'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        requestNochesLiberdadas();
    }, [page]);

    useEffect(() => {
        requestNochesLiberdadas();
    }, [selectedYear]);

    useDidUpdateEffect(() => {
        const delayFunction = setTimeout(() => {
            requestNochesLiberdadas();
        }, 500);
        return () => clearTimeout(delayFunction);
    }, [search]);

    return (
        <div className="py-3 px-5">
            <Heading size={"lg"}>{t('RELEASED_NIGHTS')}</Heading>
            <div style={{width: '100%', display: 'flex'}}>
                <Input
                    type="text"
                    placeholder={t('SEARCH_BY_NAME_OR_EMAIL')}
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                    }}
                    mr={"5"}
                />
                <div style={{minWidth: '400px', maxWidth: '100%'}}>
                    <Select
                        options={yearList}
                        onChange={(value) => {
                            setSelectedYear(value);
                        }}
                        value={selectedYear}
                        placeholder={t('FILTER_BY_YEAR')}
                        isClearable={true}
                    />
                </div>
            </div>
            <div
                className="mt-1"
                style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                }}
            >
                <TableContainer>
                    <Table variant={"simple"}>
                        <Thead>
                            <Tr>
                                <Th>{t('NAME')}</Th>
                                <Th>{t('EMAIL')}</Th>
                                <Th>{t('MEMBERSHIP_NUMBER')}</Th>
                                <Th>{t('CABIN_TYPE')}</Th>
                                <Th>{t('DATE')}</Th>
                                <Th>{t('LOW_SEASON_NIGHTS')}</Th>
                                <Th>{t('HIGH_SEASON_NIGHTS')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                nochesLiberadas.map((nocheLiberada) => (
                                    <Tr key={nocheLiberada.id}>
                                        <Td>{`${nocheLiberada.titular.nombre} ${nocheLiberada.titular.apellidos}`}</Td>
                                        <Td>{nocheLiberada.titular.correo}</Td>
                                        <Td>{nocheLiberada.titular.membresia}</Td>
                                        <Td>{nocheLiberada.titular.tipoCabana}</Td>
                                        <Td>{nocheLiberada.fechaLiberacion.split("T")[0]}</Td>
                                        <Td>{nocheLiberada.numeroNoches}</Td>
                                        <Td>{nocheLiberada.nochesAlta}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <Pagination
                pageCount={totalPages}
                currentPage={page}
                onPageChange={(newPage) => {
                    setPage(newPage);
                }}
            />
            <div className="flex justify-end mt-3">
                <Button
                    colorScheme="teal"
                    onClick={generateCSV}
                    isLoading={loading}
                    loadingText={t('GENERATING_CSV')}
                    disabled={nochesLiberadas.length === 0}
                    className="w-1/4"
                >
                    {t('DOWNLOAD_CSV')}
                </Button>
            </div>
        </div>
    );
}

export default Libreaciones;